import { formatDateToMonthYear } from "~/providers/utils";
import { MultiPsychMedicationInThePastResponse } from "~/providers/utils/types/rawResponsesTypes";

interface MultiPsychMedicationInThePastProps {
  questionCode: string;
  answers: MultiPsychMedicationInThePastResponse[];
}

export const MultiPsychMedicationInThePast = ({
  questionCode,
  answers,
}: MultiPsychMedicationInThePastProps) =>
  answers.map((med) => (
    <div key={questionCode} className="flex flex-col gap-4">
      {med.medications_data.map((complementedMed) => (
        <div key={questionCode}>
          <p>{`${complementedMed.medication} (${formatDateToMonthYear(
            complementedMed.date_started,
          )} to ${formatDateToMonthYear(complementedMed.date_stopped)})`}</p>
          <p>{`How did it work: ${complementedMed.how_did_it_work}`}</p>
          <p>{`Why did you stop: ${complementedMed.why_it_stopped}`}</p>
        </div>
      ))}
    </div>
  ));
